"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.loadState = () => {
    try {
        const serializedState = localStorage.getItem('state');
        if (serializedState === null) {
            return undefined;
        }
        // TODO: Remove after the sprint release
        const auth = JSON.parse(serializedState);
        if (auth && auth.accessToken && !auth.organization) {
            return Object.assign({}, auth, { organization: {
                    routePrefix: 'main',
                    marker: true
                } });
        }
        return auth;
        // Replace with return JSON.parse(serializedState);
    } catch (error) {
        return undefined;
    }
};
exports.saveState = state => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem('state', serializedState);
    } catch (error) {}
};


//////////////////
// WEBPACK FOOTER
// ./client/src/localStorage.ts
// module id = 576
// module chunks = 0 1 2